export const EXCLUDED_INSTRUCTIONS = [
    'Bag Added To Trip',
    'Added to Bag',
    'System weight captured',
    'Bag Received at Facility',
    'Shipment not received from client',
    'Shipment Picked Up at Origin Center',
    'Shipment Recieved at Origin Center',
    'Added to Dispatch',
    'Call placed to consignee',
    'Trip Arrived',
    'Bad/Incomplete Address',
    'Vehicle Departed',
    'Unexpected scan',
    'Vehicle delayed - Controllable',
    'Pickup not attempted',
    'Shipper unavailable',
    'Misrouted',
    'Package details changed by shipper',
    'Shipment picked up',
    'Agent remark incorrect',
    'NTD Updated',
    'Package Missing in Audit',
    'Package found in Audit',
    'Paid through link',
    'Consignee refused to accept/order cancelled',
    'Manifest uploaded',
    'Consignee Unavailable',
    'Vehicle delayed - Controllable',
    'Reattempt as per Client\'s instruction',
    'Incomplete address & contact details',
    'Shipment not ready for pickup',
    'Consignee did not receive the Code',
    'weight captured',
    'Short Bag',
    'Dispatched for RTO',
    'Yet to Pickup',
    'Received At Delhivery Hub',
];

export const STATUS_CONFIG = {
    CANCELLED: {
        instruction: 'Order Cancelled',
        isGreen: true,
        isActive: true,
        index: 1
    },
    RETURN: {
        instruction: 'To be returned soon',
        isGreen: false,
        isActive: false
    }
};

export const ORDER_STATUSES = {
    CANCELLED: 'CANCELLED',
    RETURN: 'RETURN',
    READY_FOR_PICKUP: 'READY_FOR_PICKUP',
    PENDING: 'PENDING',
    SHIPPED: 'SHIPPED'
};

export const getDeliveryText = (deliveryDate) => {
    if (!deliveryDate) return 'To be delivered soon';
    
    // Extract date from delivery string
    const deliveryDateOnly = deliveryDate.split('T')[0];
    
    // Get today and tomorrow in local timezone (IST)
    const now = new Date();
    const today = now.toLocaleDateString('en-CA'); // en-CA gives YYYY-MM-DD format
    
    const tomorrowDate = new Date(now);
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    const tomorrow = tomorrowDate.toLocaleDateString('en-CA');
    
    if (deliveryDateOnly === today) {
        return 'Arriving today';
    } else if (deliveryDateOnly === tomorrow) {
        return 'Arriving tomorrow';
    } else {
        return 'To be delivered soon';
    }
};

export const POLLING_INTERVAL = 30000; // 30 seconds
export const ANIMATION_DELAY = 1050; // milliseconds per scan item